import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { Modal, ModalActions } from "../../../../../Components/Modal";
import ModalTitle from "../../../../../Components/Modal/ModalTitle";
import ModalBody from "../../../../../Components/Modal/ModalBody";
import { useTranslation } from "../../../../../context/Internationalization";

const ClubChooseConfirmationModal = ({ open, onClose, onSave, clubName }) => {
  const { t } = useTranslation();

  const handleSave = () => {
    onSave();
  };

  return (
    <Modal open={open} onClose={onClose} type={"info"}>
      <ModalTitle title={t("choose_club_modal_title")} />
      <ModalBody>
        <span>
          {`${t("choose_club_confirmation_msg1")} ${clubName?.trim("")}. ${t(
            "choose_club_confirmation_msg2"
          )}`}
        </span>
      </ModalBody>
      <ModalActions>
        <Button
          variant={"outlined"}
          color={"secondary"}
          fullWidth
          onClick={onClose}
        >
          {t("close")}
        </Button>
        <Button fullWidth onClick={handleSave} variant="contained" color="primary">
          {t("save")}
        </Button>
      </ModalActions>
    </Modal>
  );
};

ClubChooseConfirmationModal.propTypes = {};

export default ClubChooseConfirmationModal;
